"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EList = void 0;
var EList;
(function (EList) {
    EList["DROPDOWN"] = "DROPDOWN";
    EList["CHECKBOX"] = "CHECKBOX";
    EList["RADIOBOX"] = "RADIOBOX";
})(EList || (exports.EList = EList = {}));
